import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, KeepAlive as _KeepAlive, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["inert", "aria-busy"]
const _hoisted_2 = ["inert"]
const _hoisted_3 = {
  key: 0,
  "aria-label": "场景层级"
}
const _hoisted_4 = {
  key: 0,
  class: "tree-world"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "tree-main"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "page-header" }
const _hoisted_12 = {
  role: "status",
  class: "save-status"
}
const _hoisted_13 = { class: "actions" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  class: "scene-overview",
  "aria-label": "场景概览"
}
const _hoisted_16 = {
  class: "actions scene-create-actions",
  "aria-label": "新增场景内容"
}
const _hoisted_17 = {
  class: "scene-view-switch",
  role: "group",
  "aria-label": "场景编辑视图"
}
const _hoisted_18 = ["aria-pressed"]
const _hoisted_19 = ["aria-pressed"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled", "title"]
const _hoisted_22 = ["disabled", "title"]
const _hoisted_23 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 1,
  class: "error",
  role: "alert"
}
const _hoisted_26 = {
  key: 2,
  class: "card"
}
const _hoisted_27 = { class: "card-heading selection-heading" }
const _hoisted_28 = { class: "kind-badge" }
const _hoisted_29 = { class: "breadcrumb" }
const _hoisted_30 = { class: "field-grid" }
const _hoisted_31 = {
  class: "connections",
  "aria-label": "世界连接点"
}
const _hoisted_32 = { class: "card-heading" }
const _hoisted_33 = { class: "count-badge" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "hint"
}
const _hoisted_42 = {
  key: 1,
  class: "field-grid"
}
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  key: 2,
  class: "field-grid"
}
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 3,
  class: "children-section",
  "aria-label": "下级区域"
}
const _hoisted_47 = { class: "card-heading" }
const _hoisted_48 = { class: "count-badge" }
const _hoisted_49 = {
  key: 0,
  class: "child-list"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "hint"
}
const _hoisted_52 = {
  key: 3,
  class: "card empty-state"
}
const _hoisted_53 = ["disabled"]

import StudioSelectField from "../StudioSelectField.vue";
import { computed, ref, watch } from "vue";
import { toast } from "vue-sonner";
import StudioHistoryToolbar from "../StudioHistoryToolbar.vue";
import { useStudioDocumentHistory } from "../useStudioHistory";
import { downloadTextFile } from "@/utils/download";
import SectionLayout from "@/components/Layout/SectionLayout.vue";
import StudioSidebarContent from "../StudioSidebarContent.vue";
import type { StudioEditorKind } from "../studioSidebar";
import { useSceneProject } from "./useSceneProject";
import { useWorkspaceStructIds } from "../useWorkspaceStructIds";
import { nextSceneId, contactWorldOptions, updateSceneWorldId, validateSceneProject, type SceneWorld, type SceneMainArea, type SceneSubArea } from "./sceneProject";
import { exportScene } from "./sceneExporter";
import RuntimeImportButton from "../RuntimeImportButton.vue";
import SceneGraph from "./SceneGraph.vue";
import type { SceneSelection } from "./sceneGraph";

export default /*@__PURE__*/_defineComponent({
  __name: 'SceneEditor',
  props: {
    editorKind: { default: "Scene" }
  },
  emits: ["update:editorKind"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit;
const { project, busy, error, status, retry, prepareToLeave, importConfiguration: importSceneConfiguration } = useSceneProject();
async function importConfiguration(file: File) {
  if (await importSceneConfiguration(file)) choose("world", 0);
}
__expose({ prepareToLeave });
const selected = ref<{ kind: "world" | "main" | "sub"; index: number }>({ kind: "world", index: 0 });
const editorView = ref<"properties" | "graph">("properties");
function editGraphItem(selection: SceneSelection) {
  choose(selection.kind, selection.index);
  editorView.value = "properties";
}
const workspaceIds = useWorkspaceStructIds();
const search = ref("");
const world = computed(() => selected.value.kind === "world" ? project.value?.worlds[selected.value.index] : undefined);
const main = computed(() => selected.value.kind === "main" ? project.value?.mainAreas[selected.value.index] : undefined);
const sub = computed(() => selected.value.kind === "sub" ? project.value?.subAreas[selected.value.index] : undefined);
const selectedParentMain = computed(() => main.value ?? (sub.value
  ? project.value?.mainAreas.find(area => area.id === sub.value!.mainAreaId) : undefined));
const selectedParentWorld = computed(() => world.value ?? (selectedParentMain.value
  ? project.value?.worlds.find(item => item.id === selectedParentMain.value!.worldId) : undefined));
const selectedItem = computed(() => world.value ?? main.value ?? sub.value);
const historyElement = ref<HTMLElement>();
const history = useStudioDocumentHistory({
  project, element: historyElement, blocked: () => busy.value, label: "修改场景",
  afterRestore: () => { if (!selectedItem.value) choose("world", 0); },
  onError: reason => toast.error(reason instanceof Error ? reason.message : "场景恢复失败"),
});
const selectedKindLabel = computed(() => world.value ? "世界" : main.value ? "一级区域" : "二级区域");
const childAreas = computed(() => {
  if (!project.value) return [];
  if (world.value) return project.value.mainAreas.flatMap((area, index) => area.worldId === world.value!.id ? [{ ...area, index, kind: "main" as const }] : []);
  if (main.value) return project.value.subAreas.flatMap((area, index) => area.mainAreaId === main.value!.id ? [{ ...area, index, kind: "sub" as const }] : []);
  return [];
});
const breadcrumb = computed(() => {
  return [selectedParentWorld.value?.name, selectedParentMain.value?.name, sub.value?.name].filter(Boolean).join(" / ");
});
const idDraft = ref("");
watch(() => world.value ?? main.value ?? sub.value, item => { idDraft.value = item?.id ?? ""; }, { immediate: true });
const issues = computed(() => {
  if (!project.value) return [];
  try { return validateSceneProject(workspaceIds.scene(project.value)); }
  catch (error) { return [error instanceof Error ? error.message : String(error)]; }
});
function matches(item: { id: string; name: string }) { return `${item.id} ${item.name}`.toLowerCase().includes(search.value.trim().toLowerCase()); }
function showMain(item: SceneMainArea) { return matches(item) || !!project.value?.subAreas.some(child => child.mainAreaId === item.id && matches(child)); }
function showWorld(item: SceneWorld) { return matches(item) || !!project.value?.mainAreas.some(child => child.worldId === item.id && showMain(child)); }
function choose(kind: "world" | "main" | "sub", index: number) { selected.value = { kind, index }; }
function addWorld() {
  if (!project.value || busy.value) return;
  project.value.worlds.push({ id: nextSceneId(project.value.worlds), name: "新世界", contacts: [] });
  choose("world", project.value.worlds.length - 1);
}
function addMain(parent = selectedParentWorld.value) {
  if (!project.value || busy.value || !parent) return;
  project.value.mainAreas.push({ id: nextSceneId(project.value.mainAreas), name: "新一级区域", worldId: parent.id });
  choose("main", project.value.mainAreas.length - 1);
}
function addSub(parent = selectedParentMain.value) {
  if (!project.value || busy.value || !parent) return;
  project.value.subAreas.push({ id: nextSceneId(project.value.subAreas), name: "新二级区域", mainAreaId: parent.id, bgm: "0" });
  choose("sub", project.value.subAreas.length - 1);
}
function addContact(source: SceneWorld) {
  if (!project.value) return;
  const target = contactWorldOptions(project.value, source)[0];
  if (target) source.contacts.push({ key: target.id, x: "0", y: "0", z: "0" });
}
function changeId(item: SceneWorld | SceneMainArea | SceneSubArea, event: Event) {
  const input = event.target as HTMLInputElement;
  const value = input.value.trim();
  const rows = selected.value.kind === "world" ? project.value!.worlds : selected.value.kind === "main" ? project.value!.mainAreas : project.value!.subAreas;
  if (!/^\d+$/.test(value) || Number(value) > 2147483647 || rows.some(row => row !== item && Number(row.id) === Number(value))) {
    idDraft.value = item.id; input.value = item.id; toast.error("ID 必须为同类中不重复的非负 Int32 整数"); return;
  }
  const old = item.id, next = String(Number(value));
  if (selected.value.kind === "world") updateSceneWorldId(project.value!, item as SceneWorld, next);
  else item.id = next;
  idDraft.value = next;
  if (selected.value.kind === "main") project.value!.subAreas.filter(row => row.mainAreaId === old).forEach(row => { row.mainAreaId = next; });
}
function removeSelected() {
  const p = project.value; if (!p) return;
  if (world.value) {
    if (p.worlds.some(source => source !== world.value && source.contacts.some(point => Number(point.key) === Number(world.value!.id)))) { toast.warning("请先移除其他世界中关联该世界的连接点"); return; }
    if (p.mainAreas.some(row => row.worldId === world.value!.id)) { toast.warning("请先移动或删除该世界下的一级区域"); return; }
    if (!confirm(`删除世界「${world.value.name}」？`)) return;
    p.worlds.splice(selected.value.index, 1);
  } else if (main.value) {
    if (p.subAreas.some(row => row.mainAreaId === main.value!.id)) { toast.warning("请先移动或删除该一级区域下的二级区域"); return; }
    if (!confirm(`删除一级区域「${main.value.name}」？`)) return;
    p.mainAreas.splice(selected.value.index, 1);
  } else if (sub.value) {
    if (!confirm(`删除二级区域「${sub.value.name}」？`)) return;
    p.subAreas.splice(selected.value.index, 1);
  }
  choose("world", 0);
}
function exportVariables() {
  if (!project.value) return;
  try { downloadTextFile(exportScene(workspaceIds.scene(project.value)).json, "NOLOC_场景配置数据.json", "application/json"); toast.success("场景数据已导出"); }
  catch (reason) { toast.error(reason instanceof Error ? reason.message : String(reason)); }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SectionLayout, {
    title: "场景编辑",
    class: "scene-edit-section"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "historyElement",
        ref: historyElement,
        class: "scene-editor",
        inert: _unref(busy),
        "aria-busy": _unref(busy)
      }, [
        _createVNode(StudioSidebarContent, null, {
          default: _withCtx(() => [
            _createElementVNode("aside", {
              class: "scene-browser",
              inert: _unref(busy)
            }, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "tree-heading" }, [
                _createElementVNode("strong", null, "场景层级")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                class: "search",
                placeholder: "搜索区域名称或 ID",
                "aria-label": "搜索场景区域"
              }, null, 512), [
                [_vModelText, search.value]
              ]),
              (_unref(project))
                ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project).worlds, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (showWorld(item))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["tree-node", { active: world.value === item }]),
                                onClick: ($event: any) => (choose('world', index))
                              }, [
                                _createTextVNode("世界 · " + _toDisplayString(item.name || '未命名') + " ", 1),
                                _createElementVNode("small", null, _toDisplayString(item.id), 1)
                              ], 10, _hoisted_5),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project).mainAreas, (area, areaIndex) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: areaIndex }, [
                                  (area.worldId === item.id && (matches(item) || showMain(area)))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createElementVNode("button", {
                                          class: _normalizeClass(["tree-node", { active: main.value === area }]),
                                          onClick: ($event: any) => (choose('main', areaIndex))
                                        }, [
                                          _createTextVNode("一级 · " + _toDisplayString(area.name || '未命名') + " ", 1),
                                          _createElementVNode("small", null, _toDisplayString(area.id), 1)
                                        ], 10, _hoisted_7),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project).subAreas, (child, childIndex) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: childIndex }, [
                                            (child.mainAreaId === area.id && (matches(item) || matches(area) || matches(child)))
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: _normalizeClass(["tree-node tree-sub", { active: sub.value === child }]),
                                                  onClick: ($event: any) => (choose('sub', childIndex))
                                                }, [
                                                  _createTextVNode("二级 · " + _toDisplayString(child.name || '未命名') + " ", 1),
                                                  _createElementVNode("small", null, _toDisplayString(child.id), 1)
                                                ], 10, _hoisted_8))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project).mainAreas, (area, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `orphan-main-${index}`
                      }, [
                        (!_unref(project).worlds.some(row => row.id === area.worldId))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "tree-node",
                              onClick: ($event: any) => (choose('main', index))
                            }, "未关联一级 · " + _toDisplayString(area.name), 9, _hoisted_9))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project).subAreas, (area, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `orphan-sub-${index}`
                      }, [
                        (!_unref(project).mainAreas.some(row => row.id === area.mainAreaId))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "tree-node",
                              onClick: ($event: any) => (choose('sub', index))
                            }, "未关联二级 · " + _toDisplayString(area.name), 9, _hoisted_10))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "aside-note" }, "每个工作区固定一个场景，统一管理世界与区域。", -1))
            ], 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createElementVNode("main", null, [
          _createElementVNode("header", _hoisted_11, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", null, _toDisplayString(selectedItem.value?.name || '场景概览'), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(status)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(StudioHistoryToolbar, {
                history: _unref(history),
                disabled: _unref(busy)
              }, null, 8, ["history", "disabled"]),
              _createVNode(RuntimeImportButton, {
                disabled: _unref(busy),
                "import-file": importConfiguration
              }, null, 8, ["disabled"]),
              _createElementVNode("button", {
                class: "primary",
                disabled: !_unref(project) || _unref(busy) || !!issues.value.length,
                onClick: exportVariables
              }, "导出场景数据", 8, _hoisted_14)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_unref(project))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(project).worlds.length), 1),
                    _cache[25] || (_cache[25] = _createTextVNode(" 世界", -1))
                  ]),
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(project).mainAreas.length), 1),
                    _cache[26] || (_cache[26] = _createTextVNode(" 一级区域", -1))
                  ]),
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(project).subAreas.length), 1),
                    _cache[27] || (_cache[27] = _createTextVNode(" 二级区域", -1))
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("small", null, "当前工作区 · 自动保存", -1))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  "aria-pressed": editorView.value === 'properties',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (editorView.value = 'properties'))
                }, "场景属性", 8, _hoisted_18),
                _createElementVNode("button", {
                  type: "button",
                  "aria-pressed": editorView.value === 'graph',
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (editorView.value = 'graph'))
                }, "场景示意图", 8, _hoisted_19)
              ]),
              _createElementVNode("button", {
                type: "button",
                disabled: !_unref(project) || _unref(busy),
                onClick: addWorld
              }, "＋ 新增世界", 8, _hoisted_20),
              _createElementVNode("button", {
                type: "button",
                disabled: !selectedParentWorld.value || _unref(busy),
                title: selectedParentWorld.value ? `在「${selectedParentWorld.value.name}」中新增一级区域` : '请先选择一个世界或其下属区域',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (addMain()))
              }, "＋ 新增一级区域", 8, _hoisted_21),
              _createElementVNode("button", {
                type: "button",
                class: "primary",
                disabled: !selectedParentMain.value || _unref(busy),
                title: selectedParentMain.value ? `在「${selectedParentMain.value.name}」中新增二级区域` : '请先选择一个一级区域或其下属二级区域',
                onClick: _cache[4] || (_cache[4] = ($event: any) => (addSub()))
              }, "＋ 新增二级区域", 8, _hoisted_22)
            ])
          ]),
          (_unref(error))
            ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
                _createElementVNode("button", {
                  disabled: _unref(busy),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(retry)().catch(() => undefined)))
                }, "重试", 8, _hoisted_24)
              ]))
            : _createCommentVNode("", true),
          (issues.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issues.value, (issue) => {
                  return (_openBlock(), _createElementBlock("p", { key: issue }, _toDisplayString(issue), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_unref(project) && editorView.value === 'graph')
              ? (_openBlock(), _createBlock(SceneGraph, {
                  key: 0,
                  project: _unref(project),
                  selection: selected.value,
                  onSelect: _cache[6] || (_cache[6] = ($event: any) => (choose($event.kind, $event.index))),
                  onEdit: editGraphItem
                }, null, 8, ["project", "selection"]))
              : _createCommentVNode("", true)
          ], 1024)),
          (editorView.value === 'properties' && _unref(project) && (world.value || main.value || sub.value))
            ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(selectedKindLabel.value), 1),
                    _createElementVNode("h3", null, _toDisplayString(selectedItem.value?.name || '未命名'), 1),
                    _createElementVNode("p", _hoisted_29, [
                      _createTextVNode(_toDisplayString(breadcrumb.value || '未关联区域') + " ", 1),
                      _createElementVNode("span", null, "· ID " + _toDisplayString(selectedItem.value?.id), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "danger",
                    onClick: removeSelected
                  }, "删除当前项")
                ]),
                _cache[45] || (_cache[45] = _createElementVNode("h4", null, "基本信息", -1)),
                (world.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("label", null, [
                          _cache[29] || (_cache[29] = _createTextVNode("世界 ID", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((idDraft).value = $event)),
                            inputmode: "numeric",
                            onBlur: _cache[8] || (_cache[8] = ($event: any) => (changeId(world.value, $event))),
                            onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => (changeId(world.value, $event)), ["enter"]))
                          }, null, 544), [
                            [_vModelText, idDraft.value]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[30] || (_cache[30] = _createTextVNode("世界名称", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((world.value.name) = $event))
                          }, null, 512), [
                            [_vModelText, world.value.name]
                          ])
                        ])
                      ]),
                      _createElementVNode("section", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("h4", null, [
                            _cache[31] || (_cache[31] = _createTextVNode("世界连接点 ", -1)),
                            _createElementVNode("span", _hoisted_33, _toDisplayString(world.value.contacts.length), 1)
                          ]),
                          _createElementVNode("button", {
                            disabled: !_unref(contactWorldOptions)(_unref(project), world.value).length,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (addContact(world.value)))
                          }, "＋ 关联世界", 8, _hoisted_34)
                        ]),
                        _cache[36] || (_cache[36] = _createElementVNode("p", { class: "hint" }, "选择关联的目标世界，并配置对应点位坐标。每个目标世界只能关联一次。", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(world.value.contacts, (point, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "contact-row"
                          }, [
                            _createElementVNode("label", null, [
                              _cache[32] || (_cache[32] = _createTextVNode("目标世界", -1)),
                              _createVNode(StudioSelectField, {
                                modelValue: point.key,
                                "onUpdate:modelValue": ($event: any) => ((point.key) = $event)
                              }, {
                                default: _withCtx(() => [
                                  (!_unref(contactWorldOptions)(_unref(project), world.value, point.key).some(target => target.id === point.key))
                                    ? (_openBlock(), _createElementBlock("option", {
                                        key: 0,
                                        value: point.key,
                                        disabled: ""
                                      }, "无效关联 · " + _toDisplayString(point.key), 9, _hoisted_35))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactWorldOptions)(_unref(project), world.value, point.key), (target) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: target.id,
                                      value: target.id
                                    }, _toDisplayString(target.name) + " · " + _toDisplayString(target.id), 9, _hoisted_36))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[33] || (_cache[33] = _createTextVNode("X", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((point.x) = $event),
                                inputmode: "decimal"
                              }, null, 8, _hoisted_37), [
                                [_vModelText, point.x]
                              ])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[34] || (_cache[34] = _createTextVNode("Y", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((point.y) = $event),
                                inputmode: "decimal"
                              }, null, 8, _hoisted_38), [
                                [_vModelText, point.y]
                              ])
                            ]),
                            _createElementVNode("label", null, [
                              _cache[35] || (_cache[35] = _createTextVNode("Z", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((point.z) = $event),
                                inputmode: "decimal"
                              }, null, 8, _hoisted_39), [
                                [_vModelText, point.z]
                              ])
                            ]),
                            _createElementVNode("button", {
                              class: "danger",
                              onClick: ($event: any) => (world.value.contacts.splice(index, 1))
                            }, "删除", 8, _hoisted_40)
                          ]))
                        }), 128)),
                        (!world.value.contacts.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_41, "暂无关联世界。请先创建其他世界，再添加连接点。"))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (main.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("label", null, [
                        _cache[37] || (_cache[37] = _createTextVNode("一级区域 ID", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((idDraft).value = $event)),
                          inputmode: "numeric",
                          onBlur: _cache[13] || (_cache[13] = ($event: any) => (changeId(main.value, $event))),
                          onKeydown: _cache[14] || (_cache[14] = _withKeys(($event: any) => (changeId(main.value, $event)), ["enter"]))
                        }, null, 544), [
                          [_vModelText, idDraft.value]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[38] || (_cache[38] = _createTextVNode("区域名称", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((main.value.name) = $event))
                        }, null, 512), [
                          [_vModelText, main.value.name]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[39] || (_cache[39] = _createTextVNode("所属世界", -1)),
                        _createVNode(StudioSelectField, {
                          modelValue: main.value.worldId,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((main.value.worldId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project).worlds, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.id,
                                value: item.id
                              }, _toDisplayString(item.name) + " · " + _toDisplayString(item.id), 9, _hoisted_43))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (sub.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("label", null, [
                        _cache[40] || (_cache[40] = _createTextVNode("二级区域 ID", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((idDraft).value = $event)),
                          inputmode: "numeric",
                          onBlur: _cache[18] || (_cache[18] = ($event: any) => (changeId(sub.value, $event))),
                          onKeydown: _cache[19] || (_cache[19] = _withKeys(($event: any) => (changeId(sub.value, $event)), ["enter"]))
                        }, null, 544), [
                          [_vModelText, idDraft.value]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[41] || (_cache[41] = _createTextVNode("区域名称", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((sub.value.name) = $event))
                        }, null, 512), [
                          [_vModelText, sub.value.name]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[42] || (_cache[42] = _createTextVNode("所属一级区域", -1)),
                        _createVNode(StudioSelectField, {
                          modelValue: sub.value.mainAreaId,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((sub.value.mainAreaId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(project).mainAreas, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.id,
                                value: item.id
                              }, _toDisplayString(_unref(project).worlds.find(row => row.id === item.worldId)?.name) + " / " + _toDisplayString(item.name) + " · " + _toDisplayString(item.id), 9, _hoisted_45))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[43] || (_cache[43] = _createTextVNode("BGM（整数）", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((sub.value.bgm) = $event)),
                          inputmode: "numeric"
                        }, null, 512), [
                          [_vModelText, sub.value.bgm]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (world.value || main.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("h4", null, [
                          _createTextVNode(_toDisplayString(world.value ? '一级区域' : '二级区域') + " ", 1),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(childAreas.value.length), 1)
                        ])
                      ]),
                      (childAreas.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childAreas.value, (area) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: `${area.kind}-${area.index}`,
                                class: "child-item",
                                onClick: ($event: any) => (choose(area.kind, area.index))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(area.name || '未命名'), 1),
                                _createElementVNode("small", null, "ID " + _toDisplayString(area.id), 1),
                                _cache[44] || (_cache[44] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
                              ], 8, _hoisted_50))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_51, "暂无下级区域，点击右上方按钮创建。"))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (editorView.value === 'properties' && _unref(project))
              ? (_openBlock(), _createElementBlock("section", _hoisted_52, [
                  _cache[46] || (_cache[46] = _createElementVNode("h3", null, "开始编辑场景", -1)),
                  _cache[47] || (_cache[47] = _createElementVNode("p", { class: "hint" }, "从左侧选择世界或区域，或创建一个新世界。", -1)),
                  _createElementVNode("button", {
                    disabled: _unref(busy),
                    onClick: addWorld
                  }, "＋ 新建世界", 8, _hoisted_53)
                ]))
              : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})